import { render, staticRenderFns } from "./SaitenStickyNoteModal.vue?vue&type=template&id=831fa500&"
import script from "./SaitenStickyNoteModal.vue?vue&type=script&lang=ts&"
export * from "./SaitenStickyNoteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports